module.exports = __webpack_public_path__ + "public/img/img_7.a863c4a9.png";